import {responseMsg} from "../../common/ResponseMsg";
import {useForm} from "react-hook-form";
import LabelInput from '../../../shared/components/LabelInput';
import Spacer from '../../../shared/components/Spacer';
import Flex from '../../../shared/components/Flex';
import useDevice from '../../../shared/hooks/useDevice';
import ModalButton from '../../../shared/components/ModalButton';
import { useAlert } from '../../../shared/components/AlertProvider';

function AuthAddModal({rendering}) {
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors }} = useForm();
    const device = useDevice();
    const isMobile = device !== 'desktop'
    const showAlert = useAlert();

    const onSubmitHandler = (formData) => {
        if (formData.name.trim() === '') {
            showAlert({title: "주의", text: "권한 ID를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.encodedNm.trim() === '') {
            showAlert({title: "주의", text: "권한명을 입력해주세요.", type: "warning" });
            return;
        }

        fetch("/api/system/roles",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "등록완료"});
                    rendering();
                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch(error => {
            })
    }

    return (
        <>
            <div>
                <LabelInput
                    id="roleId"
                    label="권한 ID"
                    placeholder="ROLE_' 텍스트를 제외한 이름을 입력해 주세요"
                    required
                    autoFocus
                    {...register("name")}
                />
                <Spacer direction="vertical" size={15} />
                <LabelInput
                    id="roleName"
                    label="권한명"
                    placeholder="권한명을 입력해 주세요"
                    maxLength={200}
                    required
                    {...register("encodedNm")}
                />
                <Spacer direction="vertical" size={15} />
                <LabelInput
                    id="roleRemark"
                    label="비고"
                    placeholder="비고를 입력해 주세요"
                    maxLength={255}
                    {...register("comment")}
                />
            </div>

            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type='insert' onClick={handleSubmit(onSubmitHandler)} />
                <ModalButton type='cancel' onClick={rendering} />
            </Flex>
        </>
    );
}

export default AuthAddModal;